import React from 'react';
import {useTranslation} from 'react-i18next';

import ModalDialog, {ModalDialogRef} from './components/ModalDialog';
import Button from '../components/Button';
import CustomizedDialogTitle from '../components/Dialog/CustomizedDialogTitle';
import DialogContent from '../components/Dialog/DialogContent';
import DialogActions from '../components/Dialog/DialogActions';
import {ModalProps} from './types';

export const ModalConfirm: React.FC<ModalProps> = ({modal}) => {
  const {t} = useTranslation();
  const modalRef = React.useRef<ModalDialogRef>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleSubmit = async () => {
    setLoading(true);
    await modal.trigger('submit');
    setLoading(false);
    handleCloseClick();
  };

  const handleCloseClick = () => {
    modalRef.current?.close();
  };

  const handleCancelClick = () => {
    if (modal.data.callbacks?.cancel) {
      modal.trigger('cancel');
    } else {
      handleCloseClick();
    }
  };

  return (
    <ModalDialog ref={modalRef} modal={modal} maxWidth={modal.data.maxWidth || 'xxs'}>
      {modal.data?.headerText ? (
        <CustomizedDialogTitle className="h3-medium" onClose={handleCloseClick}>
          {modal.data.headerText}
        </CustomizedDialogTitle>
      ) : null}
      <DialogContent className="p-5 p-sm-6 body1-regular custom-scroll-y">
        {modal.data?.title}

        {modal.data?.content}
      </DialogContent>
      <DialogActions>
        <Button
          className="w-100 w-sm-auto"
          variant="contained"
          color={modal.data?.submitButtonColor || 'error'}
          size="large"
          onClick={handleSubmit}
          loading={loading}
        >
          {modal.data?.submitButtonText ? modal.data.submitButtonText : t('modal_submit_btn')}
        </Button>
        <Button
          className="w-100 w-sm-auto"
          variant="contained"
          color={modal.data?.cancelButtonColor || 'secondary'}
          size="large"
          autoFocus
          onClick={handleCancelClick}
        >
          {modal.data?.cancelButtonText ? modal.data.cancelButtonText : t('modal_cancel_btn')}
        </Button>
      </DialogActions>
    </ModalDialog>
  );
};

ModalConfirm.displayName = 'ModalConfirm';

export default ModalConfirm;
